// extracted by mini-css-extract-plugin
module.exports = {"button":"DealsListBO_button__2kfdq","icon":"DealsListBO_icon__JrZoJ","collapseIcon":"DealsListBO_collapseIcon__1BjpK"};